@if (isTransactionSuccess && !hideSuccessPage) {
    <div class="mt-2">
        <input type="hidden" name="adaPullchatUrl" id="adaPullchatUrl" />
        @if (response?.adaDepositStatus?.depositBlocked) {
            <show-message [type]="messageType.INFO">
                <div info>
                    <strong>
                        {{
                            'PARTY.CASHIER.web.deposit.qd.redesign.deposit.success.header'
                                | translate
                                    : {
                                          amount: response?.amount?.value | vnCurrency: response?.amount?.currencyCode,
                                      }
                        }}
                    </strong>
                    @if (isCountryUK) {
                        <p class="line-spacing">
                            {{
                                'PARTY.CASHIER.web.deposit.ada.intervention.uk.msg'
                                    | translate
                                        : {
                                              time: response?.adaDepositStatus?.expiryTime,
                                              date: response?.adaDepositStatus?.expiryDate,
                                          }
                            }}
                        </p>
                        <p
                            class="line-spacing"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.ada.intervention.gambling.msg' | translate: { gamblingControl: gamblingControlURL }
                            "></p>
                        <p
                            class="line-spacing"
                            class="float-none"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.deposit.ada.intervention.uk.msg4'
                                    | translate
                                        : {
                                              cpccContactLink: response?.adaDepositStatus?.cpccContactLink,
                                          }
                            "></p>
                    }
                    @if (!isCountryUK) {
                        <p class="line-spacing">
                            {{
                                'PARTY.CASHIER.web.ada.intervention.msg1'
                                    | translate
                                        : {
                                              time: response?.adaDepositStatus?.expiryTime,
                                              date: response?.adaDepositStatus?.expiryDate,
                                          }
                            }}
                        </p>
                        <p
                            class="line-spacing"
                            class="float-none"
                            [vnDynamicHtml]="
                                'PARTY.CASHIER.web.ada.intervention.msg2'
                                    | translate
                                        : {
                                              cpccContactLink: response?.adaDepositStatus?.cpccContactLink,
                                          }
                            "></p>
                    }
                    <b>
                        @if (showChatNotAvailable) {
                            <div>
                                @if (!isCountryUK) {
                                    <a href="javascript:void(0)" class="float-right mt-2">
                                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                                    </a>
                                }
                                @if (isCountryUK) {
                                    <a href="javascript:void(0)" class="float-right mt-2">
                                        {{ 'PARTY.CASHIER.web.deposit.chat.here.en.text' | translate }}
                                    </a>
                                }
                                <div class="zendesk-live-block">
                                    {{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}
                                </div>
                            </div>
                        }
                        @if ((pullchatEnabled || zendeskEnabled) && !showChatNotAvailable && !hideChat) {
                            <div>
                                @if (!isCountryUK) {
                                    <a (click)="triggerChat()" class="float-right mt-2">
                                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                                    </a>
                                }
                                @if (isCountryUK) {
                                    <a (click)="triggerChat()" class="float-right mt-2">
                                        {{ 'PARTY.CASHIER.web.deposit.chat.here.en.text' | translate }}
                                    </a>
                                }
                            </div>
                        }
                    </b>
                </div>
            </show-message>
        }
        @if (!response?.adaDepositStatus?.depositBlocked) {
            <div>
                <show-message [type]="messageType.SUCCESS">
                    <div success>
                        <strong
                            >{{
                                'PARTY.CASHIER.web.deposit.qd.redesign.deposit.success.header'
                                    | translate
                                        : {
                                              amount: response?.amount?.value | vnCurrency: response?.amount?.currencyCode,
                                          }
                            }}
                        </strong>
                        <strong>
                            @if (response?.rgPercentage != null) {
                                <div>
                                    @if (response?.responsibleGamingHelpUrl?.url) {
                                        <div>
                                            <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.limit.reached' | translate }}</span>
                                            @if (response?.responsibleGamingHelpUrl.url) {
                                                <span>
                                                    <a href="{{ response?.responsibleGamingHelpUrl.url }}" target="_blank">
                                                        {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.responsible.help' | translate }}
                                                    </a>
                                                </span>
                                            }
                                        </div>
                                    }
                                    @if (!response?.responsibleGamingHelpUrl || !response?.responsibleGamingHelpUrl?.url) {
                                        <div>
                                            <span>
                                                {{
                                                    'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.message'
                                                        | translate
                                                            : {
                                                                  rgPercentage: response?.rgPercentage,
                                                              }
                                                }}
                                            </span>
                                            <span>
                                                @switch (response?.rgType) {
                                                    @case ('daily') {
                                                        <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.daily' | translate }}</span>
                                                    }
                                                    @case ('weekly') {
                                                        <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.weekly' | translate }}</span>
                                                    }
                                                    @case ('monthly') {
                                                        <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.monthly' | translate }}</span>
                                                    }
                                                    @default {
                                                        <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.depositlimit' | translate }}</span>
                                                    }
                                                }
                                            </span>
                                            @if (response?.urlInfo?.url) {
                                                <span>
                                                    <a href="{{ response?.urlInfo?.url }}" target="_blank">
                                                        {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.click.here' | translate }}
                                                    </a>
                                                    {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.message1' | translate }}
                                                </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </strong>
                        @if (response?.hardStopLTMPercentage != null && response?.successMessageInfo?.showAffNetLossMsg === 'N') {
                            <div id="hardStopchatUrl" class="mr-1">
                                @if (response?.under21age) {
                                    <div>
                                        @if (isHundredPercentageHardStopReached) {
                                            <div>
                                                <strong class="line-spacing">
                                                    {{
                                                        'PARTY.CASHIER.web.yearly.hardstop.limit.success3'
                                                            | translate
                                                                : {
                                                                      limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                                  }
                                                    }}
                                                </strong>
                                            </div>
                                        }
                                        @if (!isHundredPercentageHardStopReached) {
                                            <div>
                                                <strong
                                                    class="line-spacing"
                                                    [vnDynamicHtml]="
                                                        'PARTY.CASHIER.web.yearly.hardstop.limit.success'
                                                            | translate
                                                                : {
                                                                      limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                                  }
                                                    ">
                                                </strong>
                                            </div>
                                        }
                                        <p class="line-spacing">
                                            {{ 'PARTY.CASHIER.web.deposit.prorgdeplimits.exceeded.bea' | translate }}
                                            <a href="mailto:{{ response?.playerProtectionEmail }}" target="_top">
                                                {{ response?.playerProtectionEmail }}.</a
                                            >
                                        </p>
                                        <p class="line-spacing">
                                            {{ 'PARTY.CASHIER.web.svoc.harstop.deposit.more.info' | translate }}
                                            <a href="{{ response?.hardstopInfoLink }}" target="_blank"> {{ response?.hardstopInfoLink }}. </a>
                                        </p>
                                    </div>
                                }
                                @if (!response?.under21age) {
                                    <div>
                                        <div>
                                            <strong
                                                class="line-spacing"
                                                [vnDynamicHtml]="'PARTY.CASHIER.web.yearly.affordibility.limit.header2' | translate">
                                            </strong>
                                        </div>
                                        <p
                                            class="line-spacing"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.svoc.harstop.limit.success.uk.msg1'
                                                    | translate
                                                        : {
                                                              percentage: response?.hardStopLTMPercentage,
                                                              netDepLimit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            "></p>
                                        <p class="line-spacing">
                                            {{ 'PARTY.CASHIER.web.svoc.harstop.limit.success.uk.msg2' | translate }}
                                        </p>
                                    </div>
                                }
                            </div>
                        }
                        @if (response?.hardStopMonthlyPercentage != null && response?.successMessageInfo?.showAffNetLossMsg === 'N') {
                            <div id="hardStopchatUrl" class="mr-1">
                                @if (!response?.f30DHardstopLimit) {
                                    <p class="line-spacing" (click)="monthlyLimit($event)">
                                        <strong
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.monthly.hardstop.limit.success'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            "></strong>
                                    </p>
                                }
                                @if (response?.f30DHardstopLimit) {
                                    <p class="line-spacing" (click)="monthlyLimit($event)">
                                        <strong
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.monthly.hardstop.limit.success4'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            ">
                                        </strong>
                                    </p>
                                }
                                @if (!response?.f30DHardstopLimit) {
                                    <p
                                        class="line-spacing"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstop.limit.to.be.exceeded.msg5'
                                                | translate
                                                    : {
                                                          limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                          percent: response?.hardStopMonthlyPercentage,
                                                          url: response?.contactUs,
                                                      }
                                        "></p>
                                }
                                @if (response?.f30DHardstopLimit) {
                                    <p
                                        class="line-spacing"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.hardstop.limit.to.be.exceeded.msg6'
                                                | translate
                                                    : {
                                                          limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                          percent: response?.hardStopMonthlyPercentage,
                                                          url: response?.contactUs,
                                                      }
                                        ">
                                        <br />
                                    </p>
                                }
                            </div>
                        }
                        @if (response?.successMessageInfo?.showAffNetLossMsg === 'Y') {
                            <div class="mr-1">
                                <p class="line-spacing text-bold">
                                    {{ 'PARTY.CASHIER.web.deposit.aff.high.velocity.msg1' | translate }}
                                </p>
                                <p class="line-spacing mt-1">
                                    {{ 'PARTY.CASHIER.web.deposit.aff.high.velocity.msg2' | translate }}
                                </p>
                                <p
                                    class="line-spacing mt-1"
                                    lossLimitDepositCapClick($event)
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.deposit.aff.high.velocity.msg3'
                                            | translate: { url: response?.successMessageInfo?.increaseLimitsUrl }
                                    "></p>
                            </div>
                        }
                    </div>
                </show-message>
            </div>
        }
        @if (showChatNotAvailable && !response?.hardStopMonthlyPercentage) {
            <div>
                <div class="live-help zendesk-live-block form-control">
                    <a href="javascript:void(0)" class="btn btn-chat btn-lg theme-chat w-100 mb-2">
                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                    </a>
                    <div class="zendesk-live-block">
                        {{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}
                    </div>
                </div>
            </div>
        }
        @if (
            (pullchatEnabled || zendeskEnabled) &&
            response?.hardStopLTMPercentage != null &&
            !(response?.hardStopLTMPercentage <= 100) &&
            !response?.under21age &&
            !showChatNotAvailable &&
            !hideChat
        ) {
            <div>
                <br />
                <button (click)="triggerChat()" type="button" class="btn btn-chat btn-lg theme-chat w-100 mb-2">
                    {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                </button>
            </div>
        }
        <div class="trans-details">
            <h3>
                {{ 'PARTY.CASHIER.web.deposit.success.transactiondetails' | translate }}
            </h3>
            @if (response?.instrumentNumber != null && response?.instrumentNumber?.trim() != '') {
                <div>
                    @if (response?.type != 'cc') {
                        <div>
                            @if (response?.paymentMethod?.toUpperCase() != 'INSTANTECHECKS') {
                                <div>
                                    <p>
                                        {{ 'PARTY.CASHIER.web.deposit.success.accountId' | translate }}
                                        <span class="txt-trans-lower">{{
                                            !['PAYPAL', 'PAYPALDIRECT', 'SKRILL1TAP'].includes(response?.paymentMethod.toUpperCase())
                                                ? '*****' +
                                                  response?.instrumentNumber?.substring(
                                                      response?.instrumentNumber?.length - 3,
                                                      response?.instrumentNumber?.length
                                                  )
                                                : response?.instrumentNumber
                                        }}</span>
                                    </p>
                                </div>
                            }
                            @if (response?.paymentMethod?.toUpperCase() == 'INSTANTECHECKS') {
                                <div>
                                    <p>
                                        {{ 'PARTY.CASHIER.web.deposit.success.accountId' | translate }}
                                        <span class="txt-trans-lower">{{
                                            '*****' +
                                                response?.instrumentNumber?.substring(
                                                    response?.instrumentNumber?.length - 2,
                                                    response?.instrumentNumber?.length
                                                )
                                        }}</span>
                                    </p>
                                </div>
                            }
                        </div>
                    }
                    @if (response?.type === 'cc') {
                        <div>
                            <p txt-trans-revert>
                                {{ paymentMethodDisplayName }}
                                {{ 'PARTY.CASHIER.web.deposit.success.card.ending.label' | translate }}
                                <span class="txt-trans-lower"
                                    >****{{
                                        response?.instrumentNumber?.substring(
                                            response?.instrumentNumber?.length - 4,
                                            response?.instrumentNumber?.length
                                        )
                                    }}</span
                                >
                            </p>
                        </div>
                    }
                </div>
            }
            @if (isCoralBetslipQD) {
                <div>
                    <p>
                        {{ 'PARTY.CASHIER.web.deposit.success.transactionid' | translate }}
                        <span>{{ response?.transactionId }}</span>
                    </p>
                    <p>
                        <b
                            >{{ 'PARTY.CASHIER.web.deposit.amount.label' | translate }}
                            <span>{{ response?.amount?.currencyCode | vnCurrency }} {{ response?.amount?.value }}</span></b
                        >
                    </p>
                </div>
            }
        </div>
        @if (response?.billingDescriptor != null && response?.type === 'cc') {
            <p class="billing-description">
                {{ 'PARTY.CASHIER.web.deposit.purchase.statement.text' | translate }}
                <span
                    ><b>{{ response?.billingDescriptor }}</b></span
                >
            </p>
        }
    </div>
}
